import styled from 'styled-components';
import { shadows } from 'tokens';

export const ColorSwatch = styled.div<{ color: string }>`
	width: 16px;
	height: 16px;
	border-radius: 4px;
	background: ${({ color }) => color};
	border: 1px solid ${({ theme }) => theme.gray[200]};
`;

export const PlayButtonDetached = styled.div<{ active: boolean }>`
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 6px 11px;
	height: 18px;
	margin-left: 4px;
	border-radius: 0 12px 12px 0;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
	background: ${({ theme }) => theme.gray[0]};

	&:hover {
		background: ${({ theme, active }) => (active ? theme.gray[100] : theme.gray[0])};
	}
	&:active {
		background: ${({ theme, active }) => (active ? theme.gray[200] : theme.gray[0])};
	}
`;

export const ColorPickerPopover = styled.div`
	position: absolute;
	bottom: 40px;
	right: 0;
	background: ${({ theme }) => theme.gray[0]};
	border-radius: 8px;
	box-shadow: ${shadows.md};
	padding: 12px;
	z-index: 1;
`;
